/*
 * Renderer: text / textarea  –  type="text"  |  type="textarea"
 *
 * A single-line text input or a multi-line textarea.
 * Fires `input-change` (bubbles, composed) with detail { value: string } on every keystroke.
 * Use getValue() / setValue(str) to read or write the current content programmatically.
 *
 * Attributes:
 *   placeholder – placeholder text shown when the field is empty
 *   disabled    – disables the field
 */
export const TextRenderer = {
    renderText() {
        this.clearShadow();
        const el = document.createElement('input');
        el.type        = 'text';
        el.className   = 'inputText';
        el.placeholder = this.getAttribute('placeholder') || '';
        if (this.hasAttribute('disabled')) el.disabled = true;
        el.value = this.value ?? '';

        el.addEventListener('input', () => {
            const prev = this.value;
            this.value = el.value;
            if (this.value !== prev) {
                this.dispatchEvent(new CustomEvent('input-change', {
                    bubbles: true, composed: true,
                    detail: { value: this.value },
                }));
            }
        });

        this.textInput = el;
        this.panel     = null;
        this.trigger   = null;
        this.shadowRoot.appendChild(el);
    },

    renderTextarea() {
        this.clearShadow();
        const el = document.createElement('textarea');
        el.className   = 'inputText inputTextarea';
        el.placeholder = this.getAttribute('placeholder') || '';
        if (this.hasAttribute('disabled')) el.disabled = true;
        el.value = this.value ?? '';

        el.addEventListener('input', () => {
            const prev = this.value;
            this.value = el.value;
            this.autoGrowTextarea();
            if (this.value !== prev) {
                this.dispatchEvent(new CustomEvent('input-change', {
                    bubbles: true, composed: true,
                    detail: { value: this.value },
                }));
            }
        });

        this.textInput = el;
        this.panel     = null;
        this.trigger   = null;
        this.shadowRoot.appendChild(el);
        this.autoGrowTextarea();
    },

    autoGrowTextarea() {
        const el = this.textInput;
        if (!el || el.tagName !== 'TEXTAREA') return;
        el.style.height = 'auto';
        const { borderTopWidth, borderBottomWidth } = getComputedStyle(el);
        el.style.height = `${el.scrollHeight + parseFloat(borderTopWidth) + parseFloat(borderBottomWidth)}px`;
    },
};
